export type ApiUserInfo = {
  permission: "admin" | "user";
  status: "active" | "deactive";
  id: string;
  _id: string;
  enterprise: boolean;
  demo: boolean;
  useWatermark: boolean;
  plan: string;
  credit: {
    credit: number;
    maxCredit: number;
    automationCredit: number;
  }
}

export type GetCreditsType = {
  credit: number;
  maxCredit: number;
  apiCredit: number;
  maxApiCredit: number;
  automationCredit: number;
  genCredit: {
    basic: number;
    addOn: number;
    extras?: {
      id: string;
      credit: number;
      end: number;
      start: number;
    }[];
  }
  maxGenCredit: {
    basic: number;
    addOn: number;
  }
}

type PaymentsPlanKey = string;
  // "Starter Plan" |
  // "AI Interview Free Plan" |
  // "AI Interview Starter Plan" |
  // "AI Interview Business Plan" |
  // "AI Interview Enterprise Plan" |
  // "AI Human Free Plan" |
  // "AI Human Basic Plan" |
  // "AI Human Business Plan" |
  // "AI Human Enterprise Plan" |
  // "AI Human Custom Enterprise Plan" |
  // "AI Studios Starter - 10 minutes" |
  // "AI Studios Starter - 20 minutes" |
  // "AI Studios Starter - 40 minutes" |
  // "AI Studios Starter - 60 minutes" |
  // "AI Studios Pro - 90 minutes" |
  // "AI Studios Pro - 180 minutes" |
  // "AI Studios Pro - 120 minutes" |
  // "AI Studios Pro - 240 minutes" |
  // "AI Studios Personal - 15 min" |
  // "AI Studios Personal - 30 min" |
  // "AI Studios Personal - 60 min" |
  // "AI Studios Personal - 90 min" |
  // "AI Studios Personal - Unlimited" |
  // "AI Studios Team - 30 min" |
  // "AI Studios Team - 60 min" |
  // "AI Studios Team - 90 min" |
  // "AI Studios Team - 120 min" |
  // "AI Studios Team - Unlimited" |
  // "AI Studios Enterprise";

type PaymentsPlanName = string;
  // "Free" |
  // "Basic" |
  // "Starter" |
  // "Starter Plan" |
  // "Business" |
  // "Enterprise" |
  // "Custom Enterprise" |
  // "AI Studios Starter - 10 minutes" |
  // "AI Studios Starter - 20 minutes" |
  // "AI Studios Starter - 40 minutes" |
  // "AI Studios Starter - 60 minutes" |
  // "AI Studios Pro - 90 minutes" |
  // "AI Studios Pro - 120 minutes" |
  // "AI Studios Pro - 180 minutes" |
  // "AI Studios Pro - 240 minutes" |
  // "AI Studios Personal - 15 min" |
  // "AI Studios Personal - 30 min" |
  // "AI Studios Personal - 60 min" |
  // "AI Studios Personal - 90 min" |
  // "AI Studios Personal - Unlimited" |
  // "AI Studios Team - 30 min" |
  // "AI Studios Team - 60 min" |
  // "AI Studios Team - 90 min" |
  // "AI Studios Team - 120 min" |
  // "AI Studios Team - Unlimited" |
  // "AI Studios Enterprise";

type PaymentsPlanSubscriptionPermission = string;
  // "CUSTOM_FONT" |
  // "GENERATE_AI" |
  // "SHUTTER_STOCK" |
  // "CUSTOM_LOGO" |
  // "PREMIUM_STOCK" |
  // "GENERATE_CAPTION" |
  // "CAPTION_UPLOAD" |
  // "ONECLICK_TRANSLATION" |
  // "PREMIUM_MODEL" |
  // "MULTI_MODEL" |
  // "GENERATIVE" |
  // "GESTURE" |
  // "CUSTOM_AVATAR";

export type PaymentsPlan = {
  type: "api" | "app";
  constraints: {
    biannually?: {
      automationCredit: number;
      credit: number;
      price: number;
      seats: number;
      totalTime: number;
    }
    monthly?: {
      automationCredit: number;
      credit: number;
      customAvatarSlot?: number;
      price?: number;
      seats: number;
      totalTime?: number;
      videoLength?: number;
      genCredit?: number;
      apiCredit?: number;
    }
    numberOfInterviews?: number;
    quarterly?: {
      automationCredit: number;
      credit: number;
      customAvatarSlot?: number;
      price: number;
      seats: number;
      totalTime: number;
    }
    yearly?: {
      automationCredit: number;
      credit: number;
      customAvatarSlot?: number;
      price?: number;
      seats: number;
      totalTime?: number;
      videoLength?: number;
      genCredit?: number;
      apiCredit?: number;
    }
  };
  currency: "USD" | "KRW";
  descriptions?: string[] | null;
  iconPath?: string;
  isMostPopular: boolean;
  isTrial?: true;
  mark?: string;
  needContact: boolean;
  order: number;
  planId: {
    biannually?: string;
    monthly: string;
    quarterly?: string;
    yearly?: string;
  };
  planKey: PaymentsPlanKey;
  planName: PaymentsPlanName;
  pricePerMonth: number;
  pricePerMonthByYearly?: number;
  pricePerYear?: number;
  product: "studio3.0" | "aihuman" | "interview";
  productDisplayName?: "AI Studio3.0" | "AI Interview";
  quantity?: number;
  status?: "active" | "inactive" | "";
  stripeProductId: string;
  subscriptionPermission?: PaymentsPlanSubscriptionPermission[];
}

export type PaymentsSubscriptions = {
  amount?: number;
  cancelAt?: Date;
  cancelAtPeriodEnd: boolean;
  canceledAt?: Date;
  companyId: string;
  createdAt: Date;
  currency: "usd" | "krw";
  customerId: string;
  interval: "month" | "year";
  invoiceId: string;
  items?: {
    planName: string;
    priceId: string;
    quantity: number;
    stripeProductId: string;
    subscriptionItemId: string;
    unitAmount: number;
  }[];
  plan: PaymentsPlanName;
  planId: string;
  product: "studio3.0";
  schedule?: {
    id?: string;
    interval?: "monthly" | "yearly";
    current?: {
      plan: string;
      price: string;
      quantity: number;
    }[];
    next?:
      | {
          interval: "monthly" | "yearly";
          plan: PaymentsPlanName;
          price: number;
          quantity: number;
          type: "coupon";
        }
      | {
          plan: string;
          price: string;
          quantity: number;
        }[];
    plan?: PaymentsPlanName;
    startDate?: number;
  } | null;
  seats?: number;
  servicePeriodEnd: Date;
  servicePeriodStart: Date;
  status: "incomplete_expired" | "incomplete" | "canceled" | "active";
  subscriptionId: string;
  trialEnd: Date;
  updatedAt: Date;
  userId: string;
  workspaceId?: string;
  discount?: {
    next: {
      plan: string;
      interval: "monthly" | "yearly";
      price: number;
      quantity: number;
      type: "coupon";
    }
    startDate: number;
    interval: "monthly" | "yearly";
    plan: string;
  } | null | undefined;
};

export type GetSubscriptionsType = {
  plan: PaymentsSubscriptions["plan"] | "none" | "Enterprise";
  subscriptionId?: PaymentsSubscriptions["subscriptionId"];
  plans?: PaymentsPlan[];
  seats?: PaymentsSubscriptions["seats"];
  subscriptionInfo?: PaymentsSubscriptions;
}

export enum PermissionLevel {
  free,
  personal,
  team,
  enterprise,
}

export enum PermissionName {
  CUSTOM_FONT = "customFont",
  GENERATE_AI = "generateAi",
  SHUTTER_STOCK = "shutterstock",
  CUSTOM_LOGO = "customLogo",
  PREMIUM_STOCK = "premiumStock",
  GENERATE_CAPTION = "generateCaption",
  CAPTION_UPLOAD = "captionUpload",
  ONECLICK_TRANSLATION = "oneClickTranslation",
  PREMIUM_MODEL = "premiumModel",
  MULTI_MODEL = "multiModel",
  GENERATIVE = "generative",
  GESTURE = "gesture",
  CUSTOM_AVATAR = "customAvatar",
  EXPORT_4K = "export4k",
  AUTOMATION_CHANGE_OPTIONS = "automationChangeOptions",
  AUTOMATION_PROMPT = "automationPrompt",
}

export type Permission = {
  name: keyof typeof PermissionName;
  label: string;
  value: number;
  quota?: number[];
  customizedQuota?: number;
}